<template>
    <select class="v-simple-select" v-model="selectedValue">
        <option v-for="(option, index) of (options || [])" :value="option.value" :key="index">
            {{option.label}}
        </option>
    </select>
</template>

<script>
export default {
    name: "v-simple-select",
    props: {
        options: Array,
        default: []
    },
    data() {
        return {
            selectedValue: 10,
        }
    },
    watch: {
        selectedValue() {
            this.$emit("change", this.selectedValue);
        }
    },
    methods: {
        
    }
}
</script>

<style lang="scss">
.v-simple-select {
    border: 1px solid #D8D6DE;
    border-radius: 3px;
    padding: 5px;
    background-color: transparent;
    padding: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/Select/VSimpleSelect.vue